import { configureStore } from '@reduxjs/toolkit';
import userReducer from '../features/userSlice';
import projectsReducer from '../features/projectsSlice';
import projectSlice from '../features/project/projectSlice';
import singleProject from '../features/singleProject';
import filesReducer from '../features/filesSlice';
import uploadReducer from '../features/uploadSlice';
import ProjectHistory from '../features/ProjectHistory';
import notificationsSlice from '../features/notificationsSlice';
import notiSlice from '../features/notiSlice';
import projectTasksSlice from '../features/projectTasksSlice';

export const store = configureStore({
  reducer: {
    user: userReducer,
    projects: projectsReducer,
    project: projectSlice,
    singleProject: singleProject,
    projectTasks: projectTasksSlice,
    ProjectHistory: ProjectHistory,
    notifications: notificationsSlice,
    files: filesReducer,
    noti: notiSlice,
   upload: uploadReducer
  }
});